import { formatCurrency } from '@/utils/general/browserHelper'
import EmiBankCallout from './EmiBankCallout'
import EmiBankRecoHeading from './EmiBankRecoHeading'
import { Container } from '@cleartrip/ct-design-components'
import EmiBankRatesSheet from './EmiBankRatesSheet'
import { useState } from 'react'

const EmiBankOption = ({
    emiOptionsData = [],
    processingFeeMsg = ''
}: {
    emiOptionsData: any
    processingFeeMsg: string
}) => {
    const [isCollapsed, setIsCollapsed] = useState({
        index: -1,
        type: ''
    })
    const emiOptionsDataReco = emiOptionsData?.filter?.((emiOption: any) => emiOption?.recommended)
    const emiOptionsDataNotReco = emiOptionsData?.filter?.((emiOption: any) => !emiOption?.recommended)
    const shouldShowRecommended = emiOptionsDataReco?.length > 0

    const getMonthlySubHeading = (monthly_price_headline: string, monthly_value: number) => {
        return monthly_price_headline.replace('{monthly_value}', formatCurrency(monthly_value))
    }

    const renderEmiBankCallout = (emiOptionData: any, key: string) => {
        return emiOptionData.map((emiOption: any, index: number) => {
            const {
                image_url = '',
                is_no_cost = false,
                provider_name = '',
                call_out_attributes = [],
                emi_plans_list = []
            } = emiOption || {}
            const { message = '', monthly_value = 0 } = call_out_attributes?.[0] || {}
            return (
                <>
                    <EmiBankCallout
                        imgUrl={image_url}
                        heading={provider_name}
                        subheading={getMonthlySubHeading(message, monthly_value)}
                        isNoCost={is_no_cost}
                        isOpen={isCollapsed.index === index && isCollapsed.type === key}
                        onClick={() =>
                            setIsCollapsed(
                                isCollapsed?.index > -1 && isCollapsed?.index === index && isCollapsed.type === key
                                    ? {
                                          index: -1,
                                          type: ''
                                      }
                                    : {
                                          index: index,
                                          type: key
                                      }
                            )
                        }
                    />
                    <EmiBankRatesSheet
                        planList={emi_plans_list}
                        isOpen={isCollapsed.index === index && isCollapsed.type === key}
                        processingFeeMsg={processingFeeMsg}
                    />
                </>
            )
        })
    }

    return (
        <Container className="oy-scroll">
            <EmiBankRecoHeading shouldShowRecommended={shouldShowRecommended} text={'RECOMMENDED FOR YOU'} />
            {renderEmiBankCallout(emiOptionsDataReco, 'recommended')}
            <EmiBankRecoHeading shouldShowRecommended={shouldShowRecommended} text={'OTHER OPTIONS'} />
            {renderEmiBankCallout(emiOptionsDataNotReco, 'others')}
        </Container>
    )
}

export default EmiBankOption
